import axios from "../http"; // 导入axios实例
import qs from "qs"; // 根据需求是否导入qs模块

const getCategory ={
    getShopCate(params) {
        return axios.post(`/mobile/page/cate`,qs.stringify(params));
    },
    getProductCate(params) {
        return axios.post(`/mobile/page/cate_pc`,qs.stringify(params));
    },
    getSonCate(params) {
        return axios.post(`/mobile/page/son_cate`,qs.stringify(params));
    },
    getNyqjCate(params) {
        return axios.post(`/mobile/page/nyqj_cate`,qs.stringify(params));
    },
    getNyqjHot(params) {
        return axios.post(`/mobile/page/nyqj_hot`,qs.stringify(params));
    },
    getNyqjSonHot(params) {
        return axios.post(`/mobile/page/nyqj_son_hot`,qs.stringify(params));
    },
    getManyqjCate(params) {
        return axios.post(`/mobile/page/manyqj_cate`,qs.stringify(params));
    },
    getManyqjHot(params) {
        return axios.post(`/mobile/page/manyqj_hot`,qs.stringify(params));
    },
    getManyqjSonHot(params) {
        return axios.post(`/mobile/page/manyqj_son_hot`,qs.stringify(params));
    }
    ,
    getTaotaoCate(params) {
        return axios.post(`/mobile/page/taotao_cate`,qs.stringify(params));
    },
    getTaotaoHot(params) {
        return axios.post(`/mobile/page/taotao_hot`,qs.stringify(params));
    },
    getTaotaoSonHot(params) {
        return axios.post(`/mobile/page/taotao_son_hot`,qs.stringify(params));
    },
    getZxypCate(params) {
        return axios.post(`/mobile/page/zxyp_cate`,qs.stringify(params));
    },
    getZxypHot(params) {
        return axios.post(`/mobile/page/zxyp_hot`,qs.stringify(params));
    },
    getZxypSonHot(params) {
        return axios.post(`/mobile/page/zxyp_son_hot`,qs.stringify(params));
    },
    getLlwjCate(params) {
        return axios.post(`/mobile/page/llwj_cate`,qs.stringify(params));
    },
    getLlwjHot(params) {
        return axios.post(`/mobile/page/llwj_hot`,qs.stringify(params));
    },
    getLlwjSonHot(params) {
        return axios.post(`/mobile/page/llwj_son_hot`,qs.stringify(params));
    },
    getThzqCate(params) {
        return axios.post(`/mobile/page/thzq_cate`,qs.stringify(params));
    },
    getThzqHot(params) {
        return axios.post(`/mobile/page/thzq_hot`,qs.stringify(params));
    },
    getThzqSonHot(params) {
        return axios.post(`/mobile/page/thzq_son_hot`,qs.stringify(params));
    }
}
export default getCategory;


// WEBPACK FOOTER //
// ./src/assets/js/api/require/shopcate.js